import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";
import url from "web/script/utils/url";
import TrackedButton from "../tracked-button/tracked-button";


function LeadLink(props) {
    const {
        afterOnClick,
        children,
        className,
        fromUrl,
        href,
        isSavedForLater,
        openInNewTab,
        productId,
        reason,
        type,
    } = props;

    // Generate href for tracked button from the props
    const [leadHref, setLeadHref] = useState(href);
    function onClick(event) {
        if (productId) {
            userProfiler.saveClickedLead(productId, reason);
        }

        // redirect-to-retailer looks for globals.window.opener which is set to null in ios
        // if we use the normal href and target so we need to trigger open in new tab
        // using window.open instead to get the correct behavior
        if (openInNewTab) {
            event.preventDefault();
            window.open(leadHref, "_blank");
        }

        afterOnClick && afterOnClick(event);
    }

    function constructHref(href) {
        var parsed = url.parse(href);

        parsed.searchParams.set("pageViewId", analytics.getPageViewId());
        if (reason) {
            parsed.searchParams.set("reason", reason);
        }
        if (type) {
            parsed.searchParams.set("type", type);
        }
        if (fromUrl) {
            parsed.searchParams.set("fromUrl", fromUrl);
        }

        return url.unparse(parsed);
    }

    useEffect(() => {
        function updateHref() {
            setLeadHref(constructHref(href));
        }
        updateHref();
        analytics.on("pageViewIdChanged", updateHref);
        return function cleanup() {
            analytics.off("pageViewIdChanged", updateHref);
        };
    });

    // Pass on eventCategory/Label/action
    let analyticsProps = {};
    if (isSavedForLater) {
        analyticsProps = {
            eventCategory: "affiliate",
            eventAction: "lead",
            eventLabel: "save_for_later_buy_on_store",
        };
    }
    return (
        <React.Fragment>
            {isSavedForLater ? (
                <TrackedButton {...props} href={leadHref} {...analyticsProps}>
                    {children}
                </TrackedButton>
            ) : (
                <a
                    className={className}
                    href={leadHref}
                    onClick={onClick}
                    target={openInNewTab ? "_blank" : null}
                >
                    {children}
                </a>
            )}
        </React.Fragment>
    );
}

export default LeadLink;

LeadLink.propTypes = {
    afterOnClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    fromUrl: PropTypes.string,
    href: PropTypes.string.isRequired,
    isSavedForLater: PropTypes.bool,
    openInNewTab: PropTypes.bool,
    productId: PropTypes.string,
    reason: PropTypes.string,
    type: PropTypes.string,
};

LeadLink.defaultProps = {
    isSavedForLater: false,
    openInNewTab: false,
};
